/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggletheme1Inputs */

const en_toggletheme1 = /** @type {(inputs: Toggletheme1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

const de_toggletheme1 = /** @type {(inputs: Toggletheme1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design umschalten`)
};

/**
* | output |
* | --- |
* | "Toggle theme" |
*
* @param {Toggletheme1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const toggletheme1 = /** @type {((inputs?: Toggletheme1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggletheme1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toggletheme1(inputs)
	return de_toggletheme1(inputs)
});
export { toggletheme1 as "toggleTheme" }